import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { cuesApi, timersApi } from "../../imports";
import H1 from "../H1";
import H2 from "../H2";
import { msToString } from "../helpers/time";

export default function TimeCountdown({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const { projectId } = useParams();
	const [t, setT] = useState();

	useEffect(() => {
    let intervalId;

    clearInterval(intervalId);

    if (cue.state === "running") {
        intervalId = setInterval(() => {
            const now = moment().format("x");
            const diff = cue.endAt - now;

            if (diff < 100 && ['onair', 'cuedoff'].includes(cue.status)) {
                switch (cue.onEnd) {
                    case "hold":
                        timersApi.countdownPause(cue.id, projectId, cue.endAt);
                        break;
                    case "reset":
                        timersApi.countdownReset(cue.id, projectId, cue.duration);
                        break;
                    case "offair":
                        cuesApi.updateCue(cue.id, projectId, { status: 'going', state: 'paused' });
                        break;
                    default:
                        break;
                }
            }

            setT(diff);
        }, 50);

    } else if (cue.state === "reset") {
        setT(cue.duration);
    }

    return () => clearInterval(intervalId);
}, [cue.state, cue.endAt, cue.status, cue.onEnd, cue.id, projectId, cue.duration]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<>
			{cue.pre && (
				<H2
					cue={cue}
					text={cue.pre}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
				/>
			)}
			<H1
				cue={cue}
				text={moment
					.duration(t, "milliseconds")
					.format(cue.format || "HH:mm:ss", { trim: cue.trim })}
				baseTheme={baseTheme}
				baseThemeId={baseThemeId}
				tabular={true}
				// monospace={true}
			/>
		</>
	);
}
